import {
  HiAcademicCap,
  HiBriefcase,
  HiClipboardDocumentList,
  HiSparkles,
} from "react-icons/hi2";
import careerCounselingHeroBg from "../assets/CareerCounselinghero.png";

const focusAreas = [
  {
    title: "Career exploration",
    text: "Understand interests, strengths, and long-term possibilities across multiple career paths.",
    icon: HiBriefcase,
  },
  {
    title: "Course and college mapping",
    text: "Plan subject combinations, entrance priorities, and application timelines aligned to goals.",
    icon: HiAcademicCap,
  },
  {
    title: "Profile building",
    text: "Receive guidance on projects, internships, activities, and achievements that strengthen applications.",
    icon: HiClipboardDocumentList,
  },
];

const roadmap = [
  "1:1 counselling session to identify interests, aptitude, and preferred pathways.",
  "Customized action plan with exams, colleges/courses, and key academic milestones.",
  "Ongoing reviews with students and parents to adjust strategy as goals evolve.",
];

function CareerCounseling() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${careerCounselingHeroBg})` }}
        aria-labelledby="career-counseling-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="career-counseling-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Career Counseling
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
        aria-labelledby="career-counseling-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
              Career guidance
            </p>
            <h2
              id="career-counseling-heading"
              className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl"
            >
              Make informed decisions about your future
            </h2>
            <p className="mt-4 text-pretty text-base leading-relaxed text-ink/70 sm:mt-5 sm:text-lg">
              Our career counselling program helps students and families move from
              uncertainty to clarity through structured guidance, practical planning,
              and personalized support.
            </p>
          </div>

          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {focusAreas.map((item) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.title}
                  className="rounded-2xl border border-brand/10 bg-white p-6 shadow-[0_16px_40px_-24px_rgba(30,22,51,0.22)] ring-1 ring-brand/5"
                >
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-light text-brand">
                    <Icon className="h-5 w-5" aria-hidden />
                  </span>
                  <h3 className="mt-4 text-lg font-semibold text-ink">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink/75 sm:text-base">
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>

          <div className="mt-10 rounded-2xl border border-brand/10 bg-brand-light/25 p-6 ring-1 ring-brand/5 sm:p-7">
            <div className="flex items-center gap-2">
              <HiSparkles className="h-5 w-5 text-brand" aria-hidden />
              <h3 className="text-lg font-semibold text-ink">Counselling roadmap</h3>
            </div>
            <ul className="mt-4 space-y-2">
              {roadmap.map((step) => (
                <li key={step} className="text-sm leading-relaxed text-ink/75 sm:text-base">
                  {step}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CareerCounseling;
